// removed by extract-text-webpack-plugin
module.exports = {"row":"SiteLinks-style__row__53d960d8","item":"SiteLinks-style__item__53d960d8","link":"SiteLinks-style__link__53d960d8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LinkRow/SiteLinks-style.scss
// module id = ./src/components/Footer/LinkRow/SiteLinks-style.scss
// module chunks = 4